import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

type PatchVehicleComparisonViewPayload = {
  vehicleComparisonViewId: string;
  clickedCriteria: string;
};

export const patchVehicleComparisonView = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { defaultOnMutateError, defaultOnMutateSuccess } = useAPQuery();

  return useMutation({
    mutationFn: (
      payload: PatchVehicleComparisonViewPayload
    ): Promise<string> => {
      return fetchWithAuth<string>(
        "patchDossierVehicleComparisonView",
        dossierId,
        {
          requestOptions: {
            method: "PATCH",
            body: JSON.stringify(payload),
          },
        }
      );
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
  });
};
